import Vue from 'vue'

import HilightHome from '@/views/parts/HilightHome.vue'
import WerecommendHome from '@/views/parts/WerecommendHome.vue'
import VideoHome from '@/views/parts/VideoHome.vue'
import StoriesHome from '@/views/parts/StoriesHome.vue'
import BkklistHome from '@/views/parts/BkklistHome.vue'
import HappeningHome from '@/views/parts/HappeningModule.vue'
import InstagramHome from '@/views/parts/InstagramHome.vue'

Vue.config.productionTip = false

if (document.getElementById('hilight-home')) {
  new Vue({
    render: h => h(HilightHome)
  }).$mount('#hilight-home')
}

if (document.getElementById('werecommend-home')) {
  new Vue({
    render: h => h(WerecommendHome)
  }).$mount('#werecommend-home')
}

if (document.getElementById('stories-home')) {
  new Vue({
    render: h => h(StoriesHome)
  }).$mount('#stories-home')
}

if (document.getElementById('bkklist-home')) {
  new Vue({
    render: h => h(BkklistHome)
  }).$mount('#bkklist-home')
}

if (document.getElementById('happening-home')) {
  new Vue({
    render: h => h(HappeningHome)
  }).$mount('#happening-home')
}

if (document.getElementById('instagram-home')) {
  new Vue({
    render: h => h(InstagramHome)
  }).$mount('#instagram-home')
}

if (document.getElementById('home-videos')) {
  new Vue({
    render: h => h(VideoHome)
  }).$mount('#home-videos')
}
